export const SpanError = ({ error, className }) => {
  return (
    <span className={`text-red-500 absolute text-xs ${className}`}>
      {error.message}
    </span>
  );
};
